export const isOrderMore = item => {
  return Boolean(item.customProductId && item.customProductCreated && item.isReorder);
};